//angular imports
import { Location } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnDestroy,
  signal,
  WritableSignal,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

//local imports
import { CatalogConstants, DepartmentModel, RoomModel } from '@app/catalog';
import { CatalogCommonConstants } from '@app/catalog-common';
import { SearchModel } from '@app/core';
import { BreadcrumbChangedMessage, BreadcrumbItemToggleMessage, Messenger, PresenterType } from '@app/shared';



@PresenterType({
  model: RoomModel,
  key: 'tileBottom'
})
@Component({
  selector: 'room-carousel-item-bottom',
  standalone: false,
  templateUrl: './room-carousel-item-bottom.component.html',
  styleUrl: './room-carousel-item-bottom.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RoomCarouselItemBottomComponent implements OnDestroy {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private selectedRooms: RoomModel[] = [];
  private selectedDepartments: DepartmentModel[] = [];
  private searchItems: SearchModel[] = [];
  
  public data: WritableSignal<RoomModel> = signal<RoomModel>(undefined);

  constructor(
    private messenger: Messenger
  ){
    this.messenger.subscribe(this, BreadcrumbChangedMessage, (message) => {
        if(message.breadcrumbName !== CatalogConstants.CATALOG) { 
            return;
        }
        message.breadcrumbs.forEach((item) => {
          if(item instanceof SearchModel) {
            const exists = this.searchItems.some(search => search.id === item.id);
            if (!exists) { 
            this.searchItems.push(item);
            }
          }
          if(item instanceof DepartmentModel) {
            const exists = this.selectedDepartments.some(department => department.id === item.id);
            if (!exists) {
              this.selectedDepartments.push(item);
            }
          }
          if(item instanceof RoomModel) {
           const exists = this.selectedRooms.some(room => room.id === item.id);
            if (!exists) {
              this.selectedRooms.push(item);
            } 
          }
        })
    });
  }

 public navigateToDetailPage() {
    const currentRoom = this.data();
    

    this.searchItems.forEach((searchItem) => {
      this.messenger.send(new BreadcrumbItemToggleMessage(searchItem, CatalogConstants.CATALOG));
    });

    const isAlreadySelected = this.selectedRooms.some(room => room.id === currentRoom.id);
    if (!isAlreadySelected) {
      this.messenger.send(new BreadcrumbItemToggleMessage(currentRoom, CatalogConstants.CATALOG));
    }

    
    const queryParams = {
      roomId: currentRoom.id
    }
    const searchParam = this.route.snapshot.queryParamMap.get(CatalogCommonConstants.ROUTE_PARAMS.SEARCH_KEY);

    this.router.navigate(["/catalog/room", currentRoom.id], {
      relativeTo: this.route,
      queryParams,
      queryParamsHandling: searchParam ? '' : "merge"
    });
  }


  ngOnDestroy() {
    this.messenger.unsubscribeByOwner(this);
  }
}
